import axios from 'axios';
import React, { useContext } from 'react';
import { AppState } from './AppState';

export class Api {
    public api;
    public code: number | null = null;

    public constructor(baseURL: string) {
        this.api = axios.create({
            baseURL,
            validateStatus: () => true,
        });
    }

    public post(path: string, data?: any) {
        return this.api.post(path, {
            code: this.code,
            content: data || {},
        });
    }

    public async message(message: string, appState: AppState) {
        const response = (await this.post('/message', message)).data;

        if (response.type === 'login_failure' || response.type === 'invalid_request') {
            return null;
        }

        appState.setAppState(response.content);
        return response;
    }
}

const apiContext = React.createContext<Api>(undefined!);
export const ApiProvider = apiContext.Provider;

export function useApi() {
    return useContext(apiContext);
}
